import {Link} from "@inertiajs/react";

export default function CenteredPageNumberLink({children, href, active = false, processing, disabled, settings, realPageNumber}) {
    return (
        <Link
            disabled={disabled}
            href={href}
            className={`${active ? `bg-[${settings.secondaryColour}]` : 'bg-transparent'} ${disabled ? 'opacity-50 cursor-not-allowed ' : ''} rounded-sm text-gray-800 hover:text-gray-700 inline-flex items-center px-3 py-2 text-sm font-medium`}
            aria-current="page"
            data-page-number={realPageNumber}
        >
            {children}
        </Link>
    );

}
